require.register("documenteditor/helpers/menuentries", function(exports, require, module){
  $0
  
});

